/**
 * @file FollowUs/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 * @author Mike Saxton [michael.saxton@cbc.ca]
 */

// Some pages repeat the same Follow-us links, so define and reuse from here

const LIFE_SECTION = {
    title: "Follow CBC Life",
    links: [
        {
            socialNetwork: "facebook",
            url: "https://www.facebook.com/cbclife",
        },
        {
            socialNetwork: "instagram",
            url: "https://www.instagram.com/cbclife",
        },
        {
            socialNetwork: "pinterest",
            url: "https://www.pinterest.com/cbclife",
        },
        {
            socialNetwork: "youtube",
            url: "https://www.youtube.com/cbclife",
        },
        {
            socialNetwork: "x",
            url: "https://www.x.com/CBC_life",
        },
        {
            socialNetwork: "snapchat",
            url: "https://www.snapchat.com/add/cbclife",
        },
    ],
};

// 'Follow Us' social links by section
// Item Structure:
//   sectionName: Configuration for "Follow Us" box by section. 'sectionName' is the content section name (e.g. comedy)
//       title: User facing title for "Follow Us" area.
//       links: List of links
//           - socialNetwork: name of social network
//             url: link to social network

export const FOLLOWUS_LIST = {
    2017: {
        title: "Follow Canada 2017",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/cbccanada2017",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/cbc2017",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbc2017",
            },
        ],
    },
    "2017/wearecanada": {
        title: "Follow Canada 2017",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/cbccanada2017",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/cbc2017",
            },
        ],
    },
    "books/canadareads": {
        title: "Follow CBC Books",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/cbcbooks",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/cbcbooks",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcbooks/",
            },
        ],
    },
    "life/jamieoliver": LIFE_SECTION,
    "life/jamieoliver/recipes": LIFE_SECTION,
    "life/jamieoliver/watch": LIFE_SECTION,
    "news/canada/british-columbia": {
        title: "Follow CBC British Columbia",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/CBCVancouver",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/cbcnewsbc",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcvancouver",
            },
        ],
    },
    "news/canada/british-columbia/community": {
        title: "Follow CBC British Columbia",
        links: [
            {
                socialNetwork: "x",
                url: "https://x.com/cbcvancouver",
            },
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/CBCVancouver",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcvancouver",
            },
            {
                socialNetwork: "snapchat",
                url: "https://www.snapchat.com/add/cbcvancouver",
            },
            {
                socialNetwork: "youtube",
                url: "https://www.youtube.com/channel/UCiKE6mqbKmGGlNAtccn04MA",
            },
        ],
    },
    "news/canada/calgary": {
        title: "Follow CBC Calgary",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/cbccalgary",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/CBCCalgary",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbccalgary",
            },
        ],
    },
    "news/canada/calgary/community": {
        title: "Follow CBC Calgary",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/cbccalgary",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/CBCCalgary",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbccalgary",
            },
        ],
    },
    "news/canada/calgary/the-road-ahead": {
        title: "Follow CBC Calgary",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/cbccalgary",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/CBCCalgary",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbccalgary",
            },
        ],
    },
    "news/canada/edmonton": {
        title: "Follow CBC Edmonton",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/cbcedmonton/",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/CBCEdmonton",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcedmonton",
            },
        ],
    },
    "news/canada/hamilton": {
        title: "Follow CBC Hamilton",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/cbchamilton",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/CBCHamilton",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbchamilton",
            },
        ],
    },
    "news/canada/manitoba": {
        title: "Follow CBC Manitoba",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/cbcmanitoba",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/CBCManitoba",
            },
            {
                socialNetwork: "youtube",
                url: "https://www.youtube.com/user/CBCManitoba",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcmanitoba",
            },
        ],
    },
    "news/canada/manitoba/community": {
        title: "Follow CBC Manitoba",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/cbcmanitoba",
            },
            {
                socialNetwork: "x",
                url: "https://www.x.com/CBCManitoba",
            },
            {
                socialNetwork: "youtube",
                url: "https://www.youtube.com/CBCManitoba",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcmanitoba",
            },
        ],
    },
    "news/canada/montreal": {
        title: "Follow CBC Montreal",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/CBCMontreal",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/CBCMontreal",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcmontreal",
            },
        ],
    },
    "news/canada/new-brunswick": {
        title: "Follow CBC New Brunswick",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/CBCNB",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/CBCNB",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcnewbrunswick",
            },
        ],
    },
    "news/canada/newfoundland-labrador": {
        title: "Follow CBC Newfoundland and Labrador",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/cbcnl",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/cbcnl",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcnl",
            },
            {
                socialNetwork: "youtube",
                url: "https://www.youtube.com/c/cbcnl",
            },
        ],
    },
    "news/canada/north": {
        title: "Follow CBC North",
        links: [
            {
                socialNetwork: "x",
                url: "https://x.com/CBCNorth",
            },
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/CBCNorth/?ref=aymt_homepage_panel",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcnorth/",
            },
        ],
    },
    "news/canada/nova-scotia": {
        title: "Follow CBC Nova Scotia",
        links: [
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbc_eastcoast",
            },
            {
                socialNetwork: "youtube",
                url: "https://www.youtube.com/channel/UCxQXcwZ1Ls0spDyHCpwUs4Q",
            },
        ],
    },
    "news/canada/ottawa": {
        title: "Follow CBC Ottawa",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/CBCOttawa",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/CBCOttawa",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcottawa",
            },
        ],
    },
    "news/canada/prince-edward-island": {
        title: "Follow CBC PEI",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/CBCPEI",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/CBCPEI",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcpei",
            },
        ],
    },
    "news/canada/saskatchewan": {
        title: "Follow CBC Saskatchewan",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/cbcsask",
            },
            {
                socialNetwork: "tiktok",
                url: "https://www.tiktok.com/discover/CBC-News-Saskatchewan",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcsask",
            },
            {
                socialNetwork: "youtube",
                url: "https://www.youtube.com/channel/UCvdbpUpDg1cA4f_Jfg_-_TQ",
            },
        ],
    },
    "news/canada/saskatchewan/community": {
        title: "Follow CBC Saskatchewan",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/cbcsask",
            },
            {
                socialNetwork: "tiktok",
                url: "https://www.tiktok.com/discover/CBC-News-Saskatchewan",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcsask",
            },
            {
                socialNetwork: "youtube",
                url: "https://www.youtube.com/channel/UCvdbpUpDg1cA4f_Jfg_-_TQ",
            },
        ],
    },
    "news/canada/saskatoon": {
        title: "Follow CBC Saskatoon",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/CBCSaskatoon/",
            },
            {
                socialNetwork: "tiktok",
                url: "https://www.tiktok.com/discover/CBC-News-Saskatchewan",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcsask",
            },
            {
                socialNetwork: "youtube",
                url: "https://www.youtube.com/channel/UCvdbpUpDg1cA4f_Jfg_-_TQ",
            },
        ],
    },
    "news/canada/toronto": {
        title: "Follow CBC Toronto",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/CBCToronto",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/CBCToronto",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbctoronto",
            },
        ],
    },
    "news/canada/windsor": {
        title: "Follow CBC Windsor",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/CBCWindsor",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/CBCWindsor",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcwindsor/",
            },
        ],
    },
    "news/marketplace": {
        title: "Follow Marketplace",
        links: [
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/cbcmarketplace",
            },
            {
                socialNetwork: "x",
                url: "https://www.x.com/cbcmarketplace",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/cbcmarketplace",
            },
            {
                socialNetwork: "youtube",
                url: "https://www.youtube.com/playlist?list=PLeyJPHbRnGaZmzkCwy3-8ykUZm_8B9kKM",
            },
        ],
    },
    "news/politics/powerandpolitics": {
        title: "Follow Power & Politics",
        links: [
            {
                socialNetwork: "youtube",
                url: "https://www.youtube.com/playlist?list=PLeyJPHbRnGaZ1LGEJXLVGF87go3CuPlWo",
            },
            {
                socialNetwork: "x",
                url: "https://x.com/PnPCBC",
            },
            {
                socialNetwork: "facebook",
                url: "https://www.facebook.com/CBCPolitics/",
            },
            {
                socialNetwork: "instagram",
                url: "https://www.instagram.com/pnpcbc/",
            },
        ],
    },
};

// Configuration for social buttons used in "Follow Us" area
// Item Structure:
//   socialType: Configuration for specific social button.  'socialType' should represent the social medium (e.g. facebook)
//       displayName: User facing name for social medium.
//       imageUrl: Button image
//       userAction: Type of action the user takes for this type of social medium.

export const FOLLOWUSLOCATIONS_LIST = {
    facebook: {
        displayName: "Facebook",
        imageUrl:
            "https://i.cbc.ca/1.4586793.1521664140!/fileImage/httpImage/facebook.png",
        userAction: "Like",
    },
    gplus: {
        displayName: "Google+",
        imageUrl:
            "https://i.cbc.ca/1.4586806.1521664341!/fileImage/httpImage/reddit.png",
        userAction: "Join",
    },
    instagram: {
        displayName: "Instagram",
        imageUrl:
            "https://i.cbc.ca/1.4586808.1521664476!/fileImage/httpImage/instagram.png",
        userAction: "Follow",
    },
    linkedin: {
        displayName: "LinkedIn",
        imageUrl:
            "https://i.cbc.ca/1.4586847.1521665060!/fileImage/httpImage/linkedin.png",
        userAction: "Follow",
    },
    newsletter: {
        displayName: "the CBC Newsletter",
        imageUrl:
            "https://i.cbc.ca/1.4586850.1531937054!/fileImage/httpImage/newsletter.png",
        userAction: "Sign up for the best of",
    },
    pinterest: {
        displayName: "Pinterest",
        imageUrl:
            "https://i.cbc.ca/1.4586853.1521665185!/fileImage/httpImage/pinterest.png",
        userAction: "Follow",
    },
    reddit: {
        displayName: "reddit",
        imageUrl:
            "https://i.cbc.ca/1.4586856.1521665243!/fileImage/httpImage/reddit.png",
        userAction: "Subscribe to",
    },
    snapchat: {
        displayName: "Snapchat",
        imageUrl:
            "https://i.cbc.ca/1.4586861.1521665368!/fileImage/httpImage/snapchat.png",
        userAction: "Add",
    },
    x: {
        displayName: "X",
        imageUrl:
            "https://i.cbc.ca/1.4586863.1701965776!/fileImage/httpImage/x.png",
        userAction: "Follow",
    },
    youtube: {
        displayName: "YouTube",
        imageUrl:
            "https://i.cbc.ca/1.4586869.1521665472!/fileImage/httpImage/youtube.png",
        userAction: "Subscribe to",
    },
    tiktok: {
        displayName: "TikTok",
        imageUrl:
            "https://i.cbc.ca/1.6802267.1680707048!/fileImage/httpImage/tik-tok-icon.png",
        userAction: "Subscribe to",
    },
    podcast: {
        displayName: "Podcast",
        imageUrl:
            "https://i.cbc.ca/1.4586880.1521665636!/fileImage/httpImage/podcast.png",
        userAction: "Listen to",
    },
};
